  $(document).ready(function(){
  

  window.addEventListener('load', function () {
    initCartUpsellSlider();
  });

  document.addEventListener('cart:rendered', () => {
    initCartUpsellSlider();
  });
  function refreshCart() {
 return $.getJSON('/?sections=cart-drawer').then(function (data) {
      const $html = $('<div>').html(data['cart-drawer']);

      // Update shipping bar
      $('.shipping-progress').replaceWith($html.find('.shipping-progress'));

      // Update cart items
      $('.cart-drawer__body').html($html.find('.cart-drawer__body').html());

      // Update total
      $('.totol__price').html($html.find('.totol__price').html());
      updateCartDrawer();
      // Update upsell section
      const $newUpsell = $html.find('.cart-upsell');

    if ($newUpsell.length) {
  $('.cart-upsell').replaceWith($newUpsell);
} else {
  // No upsell left, remove the old section
  $('.cart-upsell').remove();
}
      setTimeout(() => {
        initCartUpsellSlider();
  
      }, 500);
    });
  }

$(document)
  .off('click.cartUpsell')
  .on('click.cartUpsell', '.cart-upsell__add', function (e) {
    const $btn = $(this);

    if ($btn.prop('disabled')) return;

    $btn.prop('disabled', true).text('Adding...');

    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      data: {
        id: $btn.data('variant'),
        quantity: 1,
      },
    })
      .done(function () {
        refreshCart();
      })
      .fail(function () {
        $btn.prop('disabled', false).text('Add');
      });
  });

  })
